import _ from 'lodash';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default function useOrg() {
  const store = useStore();
  const org = computed(() => _.get(store, 'state.Orgs.org'));
  return { orgRef: org };
}
